// extracted by mini-css-extract-plugin
module.exports = {"root":"ScenarioBids_root__2eHME","noNavRoot":"ScenarioBids_noNavRoot__3kLuk","main":"ScenarioBids_main__20sIe","quoteWrapper":"ScenarioBids_quoteWrapper__2jb9e"};